<i18n lang="json">
{
  "ru": {
    "ru": "Русский",
    "ab": "Аҧсуа",
    "en": "English",
    "tr": "Türkçe",
    "es": "Español",
    "ar": "العربية",
    "zh": "中文"
  },
  "en": {
    "ru": "Русский",
    "ab": "Аҧсуа",
    "en": "English",
    "tr": "Türkçe",
    "es": "Español",
    "ar": "العربية",
    "zh": "Chinese"
  }
}
</i18n>

<template>
  <div class="relative inline-block text-left">
    <button
      type="button"
      class="inline-flex w-full justify-center items-center gap-2 rounded-md border border-transparent bg-white px-2 py-2 text-sm font-sans text-gray-700 shadow-sm hover:border-darkGrey focus:ring-1 focus:outline-none transition"
      @click="open = !open"
    >
      <component :is="getIconComponent(languageSelector)" class="w-5 h-5" />
      <span>{{ t(languageSelector) }}</span>
      <svg
        class="w-4 h-4 text-gray-500"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>

    <transition
      enter-active-class="transition duration-500 ease-out"
      enter-from-class="opacity-0 translate-y-[-10px] scale-95"
      enter-to-class="opacity-100 translate-y-0 scale-100"
      leave-active-class="transition duration-400 ease-in"
      leave-from-class="opacity-100 translate-y-0 scale-100"
      leave-to-class="opacity-0 translate-y-[-10px] scale-95"
    >
      <div
        v-if="open"
        class="absolute right-0 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg border border-gray z-[9999]"
      >
        <ul class="py-1">
          <li
            v-for="locale in availableLocales"
            :key="locale.code"
            class="flex items-center gap-2 px-4 py-2 text-sm text-gray-500 hover:bg-yellow-50 cursor-pointer"
            @click="changeLocale(locale.code)"
          >
            <component :is="getIconComponent(locale.code)" class="w-5 h-5" />
            <span>{{ t(locale.code) }}</span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "#app";
import { useSwitchLocalePath } from "#i18n";

import aIconFlagRu from "@/components/a-icon/a-icon-flag-ru.vue";
import aIconFlagAb from "@/components/a-icon/a-icon-flag-ab.vue";
import aIconFlagEs from "@/components/a-icon/a-icon-flag-es.vue";
import aIconFlagTr from "@/components/a-icon/a-icon-flag-tr.vue";
import aIconFlagAr from "@/components/a-icon/a-icon-flag-ar.vue";
import aIconFlagEn from "@/components/a-icon/a-icon-flag-en.vue";

const { t, locale, locales } = useI18n({ useScope: "local" });
const router = useRouter();
const switchLocalePath = useSwitchLocalePath();

const open = ref(false);
const languageSelector = ref(locale.value);

const availableLocales = computed(() =>
  locales.value.filter((i) => i.code !== languageSelector.value)
);

function changeLocale(code) {
  languageSelector.value = code;
  open.value = false;
  router.push(switchLocalePath(code));
}

function getIconComponent(code) {
  switch (code) {
    case "ru":
      return aIconFlagRu;
    case "ab":
      return aIconFlagAb;
    case "es":
      return aIconFlagEs;
    case "tr":
      return aIconFlagTr;
    case "ar":
      return aIconFlagAr;
    case "en":
      return aIconFlagEn;
  }
}
</script>
